// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteConfirmationDialogStyles_container__1fs__","text":"DeleteConfirmationDialogStyles_text___IKr8","buttons":"DeleteConfirmationDialogStyles_buttons__2CRPt"};